module.exports = __webpack_public_path__ + "media/packs/images/flags/PR-100a7e0af959efa048060f27329aa9db.svg";